export const MODULE = 'SPECIAL_PERMIT';

export const GET_TOTAL_STATS = `${MODULE}/get_total_stats`;
export const GET_GRAPH_STATS = `${MODULE}/get_graph_stats`;

export const LEGENDS = [
  { name: 'PUV', color: '#5272AA', value: 0 },
  { name: 'TRICYCLE', color: '#8EEED7', value: 0 },
];
